(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('MonitoringRuleHistoryCreateTicketController', MonitoringRuleHistoryCreateTicketController);

    MonitoringRuleHistoryCreateTicketController.$inject = ['$scope', '$filter', '$uibModalInstance', 'entity', 'RedmineService', 'UserSearch'];

    function MonitoringRuleHistoryCreateTicketController($scope, $filter, $uibModalInstance, entity, RedmineService, UserSearch) {
        var vm = this;
        vm.history = entity;
        vm.users = UserSearch.searchUserArea({ offset: 0, size: 1000 });
        vm.clear = clear;
        vm.save = save;
        vm.markAsProcessed = !!entity.uuidExecution;
        vm.ruleLabel = $filter('translate')('wamasysApp.monitoringRule.typeEnum.' + entity.typeRule).replace('X', entity.param1).replace('Y', entity.nbDays);
        vm.redmineIssue = {
            subject: '[Monitoring] ' + vm.ruleLabel + ' - ' + (entity.areaName || ''),
            description: [
                'Date : ' + $filter('date')(entity.executionDate, 'dd/MM/yyyy HH:mm'),
                'Zone : ' + (entity.areaName || ''),
                'Regle : ' + vm.ruleLabel,
                'Valeur : ' + entity.errorValue + (entity.suffixErreur || ''),
                '',
                'Elements en erreur :',
                entity.errorItems || ''
            ].join('\n')
        };

        if (entity.firstRefContrat) {
            vm.redmineIssue.contractReference = entity.firstRefContrat;
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            RedmineService.createIssue(vm.redmineIssue, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            $scope.$emit('wamasysApp:redmineUpdate', result);
            $uibModalInstance.close({
                ticket: result,
                markAsProcessed: vm.markAsProcessed,
                uuidExecution: vm.history.uuidExecution
            });
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }
    }
})();
